<template>
  <div class="content-wrapper">
    <div class="vx-col">
      <div class="w-full flex flex-wrap item-center mb-base mt-2">
          <vs-button v-if="activeSpaceInfo.service == true" type="border" icon-pack="feather" color="primary" icon="icon-user-plus" @click="inviteMemberPopup=true" style="margin:5px;"></vs-button>
          <vs-button v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" type="flat" icon-pack="feather" color="dark" icon="icon-settings" @click="changeMember()" style="margin:5px;"></vs-button>
          <vs-button v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" type="flat" icon-pack="feather" color="danger" icon="icon-trash" @click="deleteMember()" style="margin:5px"></vs-button>
      </div>
    </div>
    <vs-popup classContent="popup-example" title="멤버 초대" :active.sync="inviteMemberPopup">
      <div class="vx-row text-left" style="margin:10px;">
      <p><strong> URL로 초대하기</strong></p>
      <vs-button color="primary" type="flat" size="small" icon-pack="feather" icon="icon-copy"/></div>
      <p style="margin:10px;"> https://filledyou.com/apps/space/dashboard/main/{{activeSpaceInfo.id}} </p>
      <p style="margin:10px;"> 검증코드: {{activeSpaceInfo.pin_number}} </p>
      <vs-divider position="center"> 또는 </vs-divider>
      <div class="vx-row text-left" style="margin:10px;">
       <p style="margin:3px;"><strong> Email로 초대하기</strong></p>
       <vs-textarea v-model="emails" placeholder="예)user01@filledyou.com;user02@filledyou.com"/> <br>
       </div>
      <vs-button class="w-full" @click="inviteMember()" color="primary" type="filled">초대하기</vs-button>
    </vs-popup>
    <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base">
       <vs-checkbox v-if="activeUserLevel >= 3" v-model="allCheckBox">전체 선택</vs-checkbox>
    </div>
    <div class="vx-row flex w-full md:w-full sm:w-1/2 mb-base">
      <InviteCard style="float: left; margin: 10px;" @selectUser="selectUser" v-for="members in workspaceMembers" :inviteInfo="members" :checkValue="members.checkValue" v-bind:key="members.id"/>
    </div>
    <div class="vx-row">
      <div class="ml-auto md:block cursor-pointer">
        <vs-popup classContent="popup-example vs-row" title="설정 변경" :active.sync="changeMemberPopup">
          <p style="margin-top:10px; margin-left:10px; margin-bottom:5px;"><strong>선택된 멤버 </strong></p>
            <component :is="scrollbarTag" style="height:80px;" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
              <div class="vx-row" style="padding:3px;">
                <div class="vx-row"  style="margin-top: -15px;">
                  <div style="margin: 5px;" v-for="member in selelteMembers" v-bind:key="member.id">

                    <div class="vx-card text-center" style="margin:5px; padding-left:5px; padding:8px;">
                      <div class="vx-card__collapsible-content" style="text-align:center;">
                        <div class="vx-row">
                    <!-- <vx-card style="margin:10px;"> -->
                        <!-- <vs-avatar size="40px"/> -->
                          <div style="text-align:center; text-overflow: ellipsis; width:80px; overflow: hidden; white-space: nowrap; display: block;">
                            {{member.name}}
                          </div>
                        </div>
                      </div>
                    <!-- </vx-card> -->
                    </div>
                  </div>
                </div>
            </div>
          </component>
        <vs-divider/>

          <div class="vx-col text-left" style="margin:10px; padding-bottom:5px;">
            <p style="margin:10px; padding-bottom:5px;"><strong> 권한설정 </strong></p>
            <ul class="centerx" style="margin:10px;">
              <li style="margin:10px; padding-bottom:3px;">
                <vs-radio v-model="radiosBox" vs-value="1">읽기 </vs-radio><br>
              </li>
              <li style="margin:10px; padding-bottom:3px;">
                <vs-radio v-model="radiosBox" vs-value="2">읽기 / 쓰기</vs-radio><br>
              </li>
              <li style="margin:10px; padding-bottom:3px;">
                <vs-radio v-model="radiosBox" vs-value="3">관리자 권한</vs-radio><br>
              </li>
            </ul>
          </div>
          <vs-button class="w-full" @click="acceptChangeMember()" color="primary" type="filled">완료</vs-button>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import InviteCard from "@/views/apps/space/dashboard/Invite/InviteCard.vue"

export default{
  props: ['inviteInfo', 'showValue'],
  components: {
    VuePerfectScrollbar,
    'InviteCard': InviteCard
  },
  data() {
      return {
        activeConfirm: false,
        // workspaceMembers: [],
        emails: '',
        radiosBox: 1,
        allCheckBox:false,
        selelteMembers:[],
        inviteMemberPopup: false,
        changeMemberPopup: false,
        settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
        },
      }
  },
  watch: {
    allCheckBox(){
      if(this.allCheckBox){
        for(var i = 0; i < this.workspaceMembers.length; i++){
          if(this.workspaceMembers[i].level != 5){
            this.$store.commit('space/UPDATE_WORKSPACE_MEMBERS_CHECKBOX', {'id':this.workspaceMembers[i].id, 'checkValue':true})
          }
        }
      } else {
        for(var j = 0; j < this.workspaceMembers.length; j++){
          if(this.workspaceMembers[j].level != 5){
            this.$store.commit('space/UPDATE_WORKSPACE_MEMBERS_CHECKBOX', {'id':this.workspaceMembers[j].id, 'checkValue':false})
          }
        }
      }
    }
  },
  computed: {
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    workspaceMembers(){
      return this.$store.state.space.workspaceMembers
    }
  },
  created() {
    // this.workspaceMembers = this.$store.state.space.workspaceMembers
    if(this.$store.state.space.ActiveSpaceInfo.id == 0 && this.workspaceMembers.length == 0){
      this.$vs.dialog({
        color: 'danger',
        title: `error`,
        text: 'Workspace 주소가 정확한지 확인해 주세요.',
        accept: this.acceptAlert
      })
      return
    }
  },
  methods:{
    acceptAlert() {
      this.$router.push('/apps/space')
    },
    selectUser(val) {
      if (val == false && this.allCheckBox == true){
        this.allCheckBox = false
      }
    },
    deleteMember(){
    this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `멤버 삭제`,
        text: '선택된 멤버을 정말 삭제하시겠습니까?',
        accept: this.deleteAlert
      })
    },
    deleteAlert() {
      this.updateSelelteMembers()
      this.$store.dispatch('space/deleteMember', {'members':this.selelteMembers, 'workspace_id': this.$store.state.space.ActiveSpaceInfo.id})
      .then((resolve)=>{
        if(resolve.data.result == 'success'){
          // this.workspaceMembers = this.$store.state.space.workspaceMembers
          this.$vs.notify({
            color: 'danger',
            title: '멤버 삭제 완료',
            text: '선택했던 멤버을 삭제하였습니다.'
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: '설정 변경 실패.',
            text: '선택했던 멤버 삭제를 실패 하였습니다. 사용자 권한을 확인해 주세요.'
          })
        }
      })
    },
    inviteMember() {
      if(!this.emails) {
        this.inviteMemberPopup = false
        return
      }
      this.$vs.loading()
      const payload = {
        id: this.activeSpaceInfo.id,
        title: this.activeSpaceInfo.title,
        emails: this.emails
      }
      this.$store.dispatch('space/inviteWorkspace', payload).then((resolve)=>{
        this.$vs.loading.close()
        if(resolve.data.result == 'success'){
          this.$vs.notify({
            color: 'success',
            title: '초대 완료',
            text: '입력하신 이메일로 초대장을 전송하였습니다.'
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: '초대 실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        }
        this.inviteMemberPopup = false
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'error',
          text: '관리자에게 문의 부탁 드립니다.'
        })
        this.inviteMemberPopup = false
      })
    },
    updateSelelteMembers(){
      this.selelteMembers = []
      for(var i = 0; i < this.workspaceMembers.length; i++){
        if (this.workspaceMembers[i].checkValue == true){
          this.selelteMembers.push(this.workspaceMembers[i])
        }
      }
    },
    changeMember () {
      this.updateSelelteMembers()
      this.changeMemberPopup = !this.changeMemberPopup
    },
    acceptChangeMember() {
      const payload = {
        members: this.selelteMembers,
        level: this.radiosBox,
        workspace_id: this.$store.state.space.ActiveSpaceInfo.id
      }
      this.$store.dispatch('space/changeMemberLevel', payload)
      .then((resolve) => {        
        this.changeMemberPopup = false
        if(resolve.data.result == 'success'){
          this.$vs.notify({
            color: 'success',
            title: '설정 변경 완료',
            text: '선택했던 멤버설정을 변경하였습니다.'
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: '설정 변경 실패.',
            text: '선택했던 일부 멤버설정을 변경 실패 하였습니다. 사용자 권한을 확인해 주세요.'
          })
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '설정 변경 실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }
}
</style>
